<template>
    <tr class="cart-table-check-stock__row">
        <td class="cart-table__column cart-table__column--image">
            <div class="image image--type--product">
                <a :href="product.product_url" class="image__body">
                    <img class="image__tag" :src="product.image" :alt="product.name">
                </a>
            </div>
        </td>
        <td class="cart-table__column cart-table__column--product">
            <a :href="product.product_ur" class="cart-table__product-name">{{ product.name }}</a><br>
            <div class="text-cart-item-number">
                <!-- <font class="text-cart-item-number">Item: {{ product.sku }}</font> -->
                <span class="text-cart-item-number">Item: {{ product.sku }}</span>
                <span class="text-cart-item-number" v-if="product.XRITMC">({{ product.XRITMC }})</span>
            </div>
            <div class="text-cart-item-manufacturer">
                <!-- <font class="text-cart-item-manufacturer">Manufacturer: {{ product.manufacturer }}</font> -->
                <span class="text-cart-item-manufacturer">Manufacturer: {{ product.manufacturername }}</span>
            </div>	
        </td>
        <td class="cart-table__column cart-table__column--price" data-title="Price">
            <p class="cart-table--price"><strong>Your Price: ${{ product.yourprice }}</strong><br>
            <strong>Core Charge: 
                <!-- <font class="text-danger">${{ product.core_charge }}</font> -->
                <span class="text-danger">${{ product.coreprice }}</span>
            </strong>
            <!-- <br>List Price: ${{ product.listprice }} -->
            </p>
        </td>
        <td class="cart-table__column cart-table__column--numeral" data-title="Shipping">
            <strong>
                <!-- <font class="text-success">{{ product.shipping_qty }}</font> -->
                <span class="text-success">{{ product.shipping_qty }}</span>
            </strong>
        </td>
        <td class="cart-table__column cart-table__column--total" data-title="Total"><strong>${{ product.total }}</strong></td>
    </tr>    
</template>

<script>
export default {
    // mixins: [Images],
    props : {
        index: {
            type: Number,
        },
        product: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            resource_img: ''
        };
    },
    created() {
        
        
    },
    updated() {
        // console.log(this.product);
        // this.getByImageByResType(this.product, 8);
    }
}
</script>

